import { render, staticRenderFns } from "./AppErrorPopup.vue?vue&type=template&id=21ec2d70"
import script from "./AppErrorPopup.vue?vue&type=script&lang=ts"
export * from "./AppErrorPopup.vue?vue&type=script&lang=ts"
import style0 from "./AppErrorPopup.vue?vue&type=style&index=0&id=21ec2d70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports